import useSipStore from '../stores/sipStore'

const STYLES = {
  disconnected: { dot: 'bg-slate-400', text: 'מנותק', cls: 'bg-slate-700/40 text-slate-300' },
  connecting:   { dot: 'bg-yellow-400 animate-pulse', text: 'מתחבר…', cls: 'bg-yellow-900/40 text-yellow-200' },
  registering:  { dot: 'bg-yellow-400 animate-pulse', text: 'נרשם…', cls: 'bg-yellow-900/40 text-yellow-200' },
  registered:   { dot: 'bg-emerald-400 animate-pulse-slow', text: 'מחובר', cls: 'bg-emerald-900/40 text-emerald-200' },
  failed:       { dot: 'bg-rose-500', text: 'שגיאה', cls: 'bg-rose-900/40 text-rose-200' },
}

export default function StatusBadge() {
  const status = useSipStore(s => s.status)
  const error = useSipStore(s => s.error)
  const style = STYLES[status] || STYLES.disconnected

  return (
    <div className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-sm font-medium ${style.cls}`}>
      <span className={`w-2 h-2 rounded-full ${style.dot}`} />
      <span>{style.text}</span>
      {error && <span className="text-xs opacity-75 ltr tech max-w-[200px] truncate">— {error}</span>}
    </div>
  )
}
